import { render, staticRenderFns } from "./smslogin.vue?vue&type=template&id=16f57cea&scoped=true&"
import script from "./smslogin.vue?vue&type=script&lang=js&"
export * from "./smslogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f57cea",
  null
  
)

export default component.exports